/**
 * How a submission reached the form route. The React forms post JSON with
 * fetch; the plain HTML twins (what a browser without JavaScript sees) post
 * form-encoded and get a redirect back. Sales sees which one it was.
 */
import { CONTRIBUTE_FORM_KEY } from './contribute';
import { PARTNER_FORM_KEY } from './partner';

/** Where a contributor pitch lands without scripts: a thank-you with no Ads conversion. */
export const CONTRIBUTE_SUCCESS_PATH = '/contributing-to-the-blog/received';

/** Where a partner application lands without scripts; no Ads conversion either. */
export const PARTNER_SUCCESS_PATH = '/partners/received';

export const FORM_TRANSPORT = {
  fetch: 'fetch',
  html: 'html',
} as const;

export type FormTransport = (typeof FORM_TRANSPORT)[keyof typeof FORM_TRANSPORT];

/** Hidden field the plain forms carry so the route knows to redirect. */
export const TRANSPORT_FIELD = 'transport';
/** Hidden field naming where the plain form redirects to after delivery. */
export const NEXT_FIELD = 'next';

/** Where each form lands after a plain HTML submission, unless it says otherwise. */
export const DEFAULT_SUCCESS_PATH: Readonly<Record<string, string>> = {
  contact: '/contact-success',
  quote: '/quote-success',
  ebook: '/contact-success',
  [CONTRIBUTE_FORM_KEY]: CONTRIBUTE_SUCCESS_PATH,
  [PARTNER_FORM_KEY]: PARTNER_SUCCESS_PATH,
};

/**
 * A redirect target the plain form is allowed to name: a path on this site.
 * Anything else (another host, a protocol-relative URL, query strings) is
 * refused so the hidden field cannot become an open redirect.
 */
export function safeNextPath(value: unknown, fallback: string): string {
  if (typeof value !== 'string') return fallback;
  return /^\/(?!\/)[A-Za-z0-9\-_/]*$/.test(value) ? value : fallback;
}
